import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { DateTime } from 'luxon';
import {JackingFormInstanceEditor} from '../../../../../models/jacking-v2/jacking.models';
import {PtLuxonDate} from '../../../../../models/projects/date.models';

@Component({
  selector: 'jacking-date-time-cell',
  templateUrl: './jacking-date-time-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JackingDateTimeCellComponent {
  @Input() id!: number | string;

  @Input() requiresDateTime = false;
  @Input() activitySpansMultipleDays = false;

  @Input() editor!: JackingFormInstanceEditor;
  @Input() isReadonly = false;
  @Input() minDate: DateTime;

  @Input() ptLuxonDate!: PtLuxonDate | string;
  @Input() timeText = '';
  @Input() mask: any[] = [];

  @Input() requiresConfirmation = false;
  @Input() confirmed = false;

  @Output() dateChanged = new EventEmitter<DateTime>();
  @Output() timeTextChanged = new EventEmitter<string>();
  @Output() offsetSelected = new EventEmitter<PtLuxonDate>();
  @Output() confirmedChanged = new EventEmitter<boolean>();

  onPickerDateChanged(dt: DateTime) {
    // ensure ptLuxonDate exists so template never hits null.dateTime
    if (!this.ptLuxonDate) {
      this.ptLuxonDate = new PtLuxonDate(undefined, true);
      this.ptLuxonDate.dateTime = null;
    }

    // update the backing object so the UI stays in sync
    (this.ptLuxonDate as PtLuxonDate).dateTime = dt;

    // emit to parent (your existing pipeline)
    this.dateChanged.emit(dt);
  }

}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-date-time-cell/jacking-date-time-cell.component.ts